import React from "react";

const NotRouteFound = () => {

    return (
        <div>
            No Content here!
        </div>
    )
}
export default NotRouteFound;
